<template lang="pug" src="./CategoryProducts/template.pug"></template>

<script>
import CategoryProducts from './CategoryProducts';

import { get, cloneDeep } from '@/helpers';

export default {
    name: 'ProductList',
    extends: CategoryProducts,
    methods: {
        refetch() {
            this.loading = true;

            const shop = get(this.cms, 'shop.id');
            let products = [];

            let shopCategories = cloneDeep(this.shopCategories);
            let categories = [];

            if (shopCategories && shopCategories.length >= 1) {
                categories = shopCategories.map(category => category.id);
            }

            let ids = [];
            if ((products = get(this.section, 'products'))) {
                ids = products.map(product => product.id);
            }

            const payload = {
                pageInfo: {
                    currentPage: parseInt(this.currentPage),
                    perPage: parseInt(this.perPage)
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'ids',
                        in: ids
                    },
                    // {
                    //     key: 'qty_sum',
                    //     from: 1
                    // },
                    {
                        key: 'categories',
                        in: categories
                    }
                ],
                order: 'date' // property:groupsort
            };
            this.fetchProducts(payload)
                .then(response => {
                    if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                        this.changePage(response.pageInfo.lastPage);
                        return;
                    }

                    const products = cloneDeep(response);
                    if (products.items && products.items.length) {
                        products.items.forEach((product, i) => {
                            product.position = i + 1;
                        });
                    }

                    this.products = products;
                    // this.insertProducts({ products });
                    this.loading = false;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
